import Widget from "@/components/widgets";
import type { WidgetConfig } from "@/types";
import { MasonryGalleryComponentWidget } from "@/features/testimonial-gallery/components/masonary";

declare global {
  interface Window {
    MasonryGalleryWidget: typeof MasonryGalleryWidget;
  }
}

class MasonryGalleryWidget extends Widget {
  static init(config: WidgetConfig) {
    return super.init(config, MasonryGalleryComponentWidget);
  }
}

if (typeof window !== "undefined") {
  window.MasonryGalleryWidget = MasonryGalleryWidget;
}

export default MasonryGalleryWidget;
